export default __webpack_public_path__ + "static/media/coupon_sent_on.86f0aaa5.png";